/* VALIDATORS */
export const emailValidator = (email) => {
  const re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/;

  if (!email || email.length <= 0)
    return "Introduzca una dirección de email válida.";
  if (!re.test(email)) return "Introduzca una dirección de email válida.";

  return "";
};

export const passwordValidator = (password) => {
  if (!password || password.length <= 0) {
    return "Introduzca una contraseña, por favor.";
  }
  else if (password.length < 6){
    return "La contraseña debe tener al menos 6 caracteres"
  }
    return "";
};

export const passwordMatchValidator = (p1, p2) => {
  if (p1 !== p2)
    return "Las contraseñas no coinciden";
  return "";
};

export const errorCodeTranslator = (e) => {
  switch (e.code) {
    case "auth/user-not-found":
      return "Usuari@ no encontrad@"
    case "auth/wrong-password":
      return "Contraseña incorrecta"
    case "auth/weak-password":
      return "La contraseña debe tener al menos 6 caracteres"
    case "auth/email-already-in-use":
      return "Ya existe una cuenta con el email indicado"
    default:
      return e.toString()
  }
}



export const profileValidator = (profileData, changedFields) => {

  const MIN_CHARS_NAME = 3

  // console.log(changedFields['isPublic'])
  // console.log('PROFILEDATA: ', profileData)

  if (Object.keys(changedFields).length === 0) {
    return "No se han realizado cambios";
  }

  if ('age' in changedFields){
    if (changedFields['age']<0 || changedFields['age']>120) {
      return "Rango de edad inválido";
    }
  }

  if ('name' in changedFields){
    if (changedFields['name'].length<MIN_CHARS_NAME) {
      return "El nombre debe tener al menos " + MIN_CHARS_NAME + " caracteres";
    }
  }

  if ('isPublic' in changedFields){
    if (changedFields['isPublic']=== true && ((profileData['name'].length<MIN_CHARS_NAME) && (changedFields['name'].length<MIN_CHARS_NAME))) {
      return "Para hacer público el perfil, debe incluir un nombre de al menos "+ MIN_CHARS_NAME +" caracteres";
    }
  }
  

  return "";
}